import PageNotFound from '../pages/404/PageNotFound';
import InternalServerError from '../pages/500/InternalServerError';
import Dashboard from '../pages/dashboard/DashboardPage';
import RegistrationsLayout from '../pages/registrations/RegistrationsLayout';
import FormPreviewPage from '../pages/registrations/preview/FormPreviewPage';
import PaymentAccountsPage from '../pages/paymentAccounts/PaymentAccountsPage';
import ReportsListPage from '../pages/reports/ReportsListPage';
import ReportsPage from '../pages/reports/ReportsPage';
import SavedReportsPage from '../pages/reports/SavedReportsPage';
import PaymentOptionsPage from '../pages/settings/payment-options/PaymentOptions';
import Organization from '../pages/organization/OrganizationPage';
import UsersPage from '../pages/users/UsersPage';
import NotificationsPage from '../pages/notifications/NotificationsPage';

const userRoutes = [
  { path: '/dashboard', component: Dashboard },
  { path: '/reports', component: ReportsListPage },
  { path: '/reports/:formId/:reportId', component: ReportsPage },
  { path: '/reports/:formId/', component: SavedReportsPage },
  { path: '/reports/:formId/create', component: ReportsPage },
  { path: '/registrations', component: RegistrationsLayout },
  { path: '/registrations/submissions/:formId/:submissionId', component: RegistrationsLayout },
  { path: '/registrations/submissions/:formId', component: RegistrationsLayout },
  { path: '/registrations/admin/create-new-form', component: RegistrationsLayout },
  { path: '/registrations/admin/edit-form/:formId', component: RegistrationsLayout },
  { path: '/registrations/draggable', component: RegistrationsLayout },
  { path: '/registrations/preview/:formId', component: FormPreviewPage },
  { path: '/users/', component: UsersPage },
  { path: '/payment-accounts', component: PaymentAccountsPage },
  { path: '/notifications', component: NotificationsPage },
  { path: '/settings/payment-options', component: PaymentOptionsPage },
  { path: '/500', component: InternalServerError },
  { path: '/organization', component: Organization },
  { component: PageNotFound },
];

export { userRoutes };
